import { type Topic } from "#/components/exam-results/views/type-2/overall";
import {
  type ExamSummeryInfo,
  type MainResultSet
} from "#/services/rest/gwt/exam-results/views/type-1/multi-user.types";
import { useBreakLG } from "@monta/design-system";
import clsx from "clsx";
import { useState } from "react";
import MultiLessonCards from "./Cards";
import styles from "./styles.module.scss";
import MultiLessonTable from "./Table";

type Props = {
  bookData: MainResultSet[];
  topicData: MainResultSet[];
  overallInfo: ExamSummeryInfo;
};

const MultiLesson = ({ bookData, topicData, overallInfo }: Props) => {
  const isDesktop = useBreakLG();
  const [category, setCategory] = useState<Topic>("book");

  return (
    <div className={styles["multiLesson"]}>
      <div className={styles["multiLesson__header"]}>
        <h2 className={styles["multiLesson__header-title"]}>
          بررسی درس به درس
        </h2>

        <div className={styles["toggle"]}>
          <div
            className={clsx(
              styles["toggle__slider"],
              category === "topic"
                ? styles["toggle__slider--right"]
                : styles["toggle__slider--left"]
            )}
          />
          <button
            onClick={() => setCategory("topic")}
            className={clsx(
              styles["toggle__option"],
              category === "topic" ? styles["toggle__option--active"] : ""
            )}
          >
            گروه درسی
          </button>
          <button
            onClick={() => setCategory("book")}
            className={clsx(
              styles["toggle__option"],
              category === "book" ? styles["toggle__option--active"] : ""
            )}
          >
            کتاب
          </button>
        </div>
      </div>

      {isDesktop ? (
        <MultiLessonTable
          participantNo={overallInfo.participantNo}
          activeCategory={category}
          data={category === "book" ? bookData : topicData}
        />
      ) : (
        <MultiLessonCards
          participantNo={overallInfo.participantNo}
          data={category === "book" ? bookData : topicData}
        />
      )}
    </div>
  );
};

export default MultiLesson;
